import { motion } from 'framer-motion'

interface SpinnerProps {
  size?: number
  color?: string
}

/**
 * Small inline-styled spinner for a button's busy state. No SCSS file --
 * this is a purely presentational, single-use component and inline styles
 * sidestep the stylelint webpack plugin for the sake of ~15 lines.
 */
export const Spinner = ({ size = 16, color = '#FFFFFF' }: SpinnerProps) => (
  <motion.span
    aria-hidden="true"
    style={{
      display: 'inline-block',
      boxSizing: 'border-box',
      width: size,
      height: size,
      border: `2px solid ${color}`,
      borderTopColor: 'transparent',
      borderRadius: '50%',
    }}
    animate={{ rotate: 360 }}
    transition={{ duration: 0.8, ease: 'linear', repeat: Infinity }}
  />
)
